<template>
  <div class="payment-account-cancel-request">
    <button @click.prevent="onClose"
            class="payment-account-cancel-request__close">
      <BaseSvg name="ico-close"/>
    </button>
    <img src="@/assets/img/payment/payment-account-cancel.svg"
         alt="message"
         class="payment-account-cancel-request__img">
    <div class="payment-account-cancel-request__text text">
      <p><b>{{$tPayment('Cancellation of the application')}}</b><br>
        {{$tPayment('Are you sure')}}
      </p>
    </div>
    <div class="payment-account-cancel-request__footer">
      <button @click.prevent="onAccept"
              class="payment-account-cancel-request__btn  base-btn  base-btn--outline-orange">
        <BaseSvg name="ico-trash" width="1.4rem" height="1.6rem"/>
        <span>{{$tPayment('Cancel the application')}}</span>
        <BasePreloader v-if="pending"
                       class="_small"/>
      </button>
      <button @click.prevent="onClose"
              class="payment-account-cancel-request__btn  base-btn  base-btn--blue-dark">
        {{$tPayment('No')}}
      </button>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import handleError from '@/helpers/handleError'

  export default {
    name: 'PaymentAccountCancelRequest',
    props: {
      onSuccess: {
        type: Function,
      }
    },
    data() {
      return {
        pending: false
      }
    },
    methods: {
      onClose() {
        this.$vModal.close('payment-account-cancel-request')
      },
      onAccept() {
        this.pending = true

        http.delete('/api/jobian-pay/remove-accord-order')
          .then(() => {
            this.onSuccess()
            this.onClose()
          })
          .catch(e => {
            const error = handleError(e)

            this.$vModal.open('warning', {
              title: error
            })
          })
          .finally(() => {
            this.pending = false
          })
      }
    }
  }
</script>

<style lang="less">

</style>
